import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import CarListing from "../pages/CarListing";
import CarDetails from "../pages/CarDetails";
import NotFound from "../pages/NotFound";
import Contact from "../pages/Contact";
import ProfLayout from "../pages/ProfLayout";
import ProfileEdit from "../pages/ProfileEdit";
import ProfileVerifications from "../pages/ProfileVerifications";
import BookingList from "../pages/BookingList";

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      {/* <Route path="/login" element={<Login />} /> */}
      <Route path="/profile" element={<ProfLayout />}>
        <Route index element={<ProfileEdit />} />
        <Route path="edit" element={<ProfileEdit />} />
        <Route path="verifyProfile" element={<ProfileVerifications />} />
        <Route path="bookings" element={<BookingList />} />
      </Route>
      <Route path="/cars" element={<CarListing />} />
      <Route path="/cars/:slug" element={<CarDetails />} />
     
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
